require("!!/home/travis/build/AhsanAyaz/ng2-emoji/example/node_modules/script-loader/addScript.js")(require("!!/home/travis/build/AhsanAyaz/ng2-emoji/example/node_modules/raw-loader/index.js!/home/travis/build/AhsanAyaz/ng2-emoji/example/node_modules/popper.js/dist/umd/popper.js"))


//////////////////
// WEBPACK FOOTER
// /home/travis/build/AhsanAyaz/ng2-emoji/example/~/script-loader!/home/travis/build/AhsanAyaz/ng2-emoji/example/~/popper.js/dist/umd/popper.js
// module id = ../../../../script-loader/index.js!../../../../popper.js/dist/umd/popper.js
// module chunks = 2